import LinearProgress from '@material-ui/core/LinearProgress';
import 'react-widgets/dist/css/react-widgets.css';
import Snackbar from '@material-ui/core/Snackbar';
import Scrollbar from 'react-scrollbars-custom';
import MuiAlert from '@material-ui/lab/Alert';
import Card from '@material-ui/core/Card';
import React, { Component } from 'react';
const isEmpty = require('is-empty');
const AWS     = require('aws-sdk');
const s3      = new AWS.S3({
	accessKeyId:     process.env.AWS_ACCESS_KEY_ID     ? process.env.AWS_ACCESS_KEY_ID     : process.env.REACT_APP_AWS_ACCESS_KEY,
	secretAccessKey: process.env.AWS_SECRET_ACCESS_KEY ? process.env.AWS_SECRET_ACCESS_KEY : process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
	apiVersion:      '2006-03-01',
	// region: 'us-east-1',
	params:          { Bucket: 'farmazon' }
});
function Alert(props) {
	return <MuiAlert elevation={6} variant="filled" {...props} />;
}
class AddNotificationModal extends Component {

	///---------------------------------------INIT-------------------------------------
	constructor(props) {
		super(props);
		this.state = {
			isRecurrent:      false,
			WEDNESDAY:        false,
			THURSDAY:         false,
			SATURDAY:         false,
			TUESDAY:          false,
			MONDAY:           false,
			FRIDAY:           false,
			SUNDAY:           false,
			errorDescription: '',
			errorFinalDate:   '',
			errorStartDate:   '',
			description:      '',
			errorTitle:       '',
			errorDays:        '',
			errorHour:        '',
			startDate:        '',
			finalDate:        '',
			title:            '',
			image:            '',
			hour:             '',
			progress:         100,
			days:             [],
			showSnackBar:     false,
			textSnackBar:     '',
			severitySnackBar: 'error',
		};
		this.previewFile       = this.previewFile.bind(this)
		this.handleInputChange = this.handleInputChange.bind(this);
		this.setDays           = this.setDays.bind(this);
	}

	componentDidUpdate(prevProps) {
		if (this.props.isVisible && this.props.isVisible !== prevProps.isVisible && this.props.notificationData) {
			this.setState({
				isRecurrent: this.props.notificationData.type === 'R' ? true : false
			});
			this.setDays();
		}
	}

	///---------------------------------------EVENTS-------------------------------------
	onChangeTitle(e) {
		this.setState({
			title: e.target.value,
		});
	}

	onChangeDescription(e) {
		this.setState({
			description: e.target.value,
		});
	}

	onChangeHour(e) {
		this.setState({
			hour: e.target.value,
		});
	}

	onChangeStartDate(e) {
		this.setState({
			startDate: e.target.value,
		});
	}

	onChangeFinalDate(e) {
		this.setState({
			finalDate: e.target.value,
		});
	}

	handleInputChange(event) {
		const target = event.target;
		const value  = target.type === 'checkbox' ? target.checked : target.value;
		const name   = target.name;
		let newDays  = this.state.days;
		if (!newDays.includes(name)) {
			newDays.push(name);
		} else {
			newDays = this.removeItemFromArr(newDays, name);
		}
		this.setState(prevState => ({
			[name]: value,
			days:   newDays
		}));
	}

	removeItemFromArr(arr, item) {
		let i = arr.indexOf(item);
		if (i !== -1) {
			arr.splice(i, 1);
		}
		return arr;
	}

	setDays() {
		if (this.props.notificationData) {
			let newDays = this.state.days;
			for (const day of this.props.notificationData.days) {
				newDays.push(day);
				this.setState({
					[day]: true
				});
			}
			this.setState({
				days: this.props.notificationData.days
			})
		}
	}

	sendImage(file) {
		const today    = new Date();
		const fileName = today.getDate() + '-' + (today.getMonth() + 1) + '-' + today.getFullYear() + '_' + today.getHours() + '-' + today.getMinutes() + '-' + today.getSeconds() + '_' + file.name;
		const params   = {
			Bucket:      'farmazon', // your s3 bucket name
			Key:         'images/push_notifications_images/' + fileName,
			key:         'images/push_notifications_images/' + fileName,
			Body:        file,
			ContentType: file.type,
			ACL:         'public-read',
		};
		s3.upload(params, (err, s3res) => {
			if (err) {
				console.log("err:", err)
			} else {
				console.log("s3res" + JSON.stringify(s3res));
				console.log("s3res.Location:", s3res.Location);
				this.setState({
					newImage: s3res.Location
				})
			}
		}).on('httpUploadProgress', function (progress) {
			const uploaded             = parseInt((progress.loaded * 100) / progress.total);
			console.log("uploaded2:", uploaded);
			let linearProgress         = document.getElementById("linearProgress");
			linearProgress.style.width = uploaded + "%";
		});
	}

	previewFile(event) {
		const file = document.querySelector('input[type=file]').files[0];
		if (file !== undefined) {
			if (file.size > 512000) {
				this.setState({
					showSnackBar:     true,
					textSnackBar:     'El archivo debe ser menor a 500 Kilobytes',
					severitySnackBar: 'error',
				});
				event.target.value = null;
				return;
			}
			this.sendImage(file);
			event.target.value = null;
		}
	}

	handleClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		this.setState({
			showSnackBar: false
		});
	};

	clearErrors() {
		this.setState({
			errorTitle:       '',
			errorDescription: '',
			errorHour:        '',
			errorDays:        '',
			errorStartDate:   '',
			errorFinalDate:   ''
		});
	}

	clearForm() {
		this.farmazonFormRef.reset();
		this.titleForm           = null;
		this.descriptionForm     = null;
		this.hourForm            = null;
		this.newImage            = null;
		this.startDateForm.value = null;
		if (this.state.isRecurrent) {
			this.finalDateForm.value = null;
		} else {
			this.finalDateForm       = null;
		}
		this.setState({
			isValidStartDate: false,
			isValidFinalDate: false,
			isValidTitle:     false,
			isRecurrent:      false,
			isValidDays:      false,
			WEDNESDAY:        false,
			THURSDAY:         false,
			SATURDAY:         false,
			TUESDAY:          false,
			MONDAY:           false,
			FRIDAY:           false,
			SUNDAY:           false,
			errorDescription: '',
			errorStartDate:   '',
			errorFinalDate:   '',
			description:      '',
			errorTitle:       '',
			errorDays:        '',
			errorHour:        '',
			startDate:        '',
			finalDate:        '',
			title:            '',
			image:            '',
			hour:             '',
			progress:         100,
			days:             [],
			newImage:         null
		});
	}

	async preparateUpdate() {
		await this.clearErrors();
		let tempId      = this.props.notificationData._id;
		let title       = this.props.notificationData.title;
		let description = this.props.notificationData.description;
		let hour        = this.props.notificationData.hour;
		let days        = this.props.notificationData.days;
		let image       = this.props.notificationData.image;
		let type        = this.props.notificationData.type === 'R' ? true : false;
		let startDate   = this.props.notificationData.startDate;
		let finalDate   = this.props.notificationData.finalDate;
		if (this.state.title       !== '' || !isEmpty(this.state.tilte))
			title = this.state.title;
		if (this.state.description !== '' || !isEmpty(this.state.description))
			description = this.state.description;
		if (this.state.hour        !== '' || !isEmpty(this.state.hour))
			hour = this.state.hour;
		if (this.state.newImage)
			image = this.state.newImage;
		if (this.state.startDate)
			startDate = this.state.startDate;
		if (this.state.finalDate)
			finalDate = this.state.finalDate;
		if (this.state.days.length > 0 || !isEmpty(this.state.days))
			days = this.state.days;
		if (this.state.isRecurrent !== type) {
			if (this.state.isRecurrent) {
				if (this.state.days.length === 0)
					this.setState({ errorDays: 'Necesitas seleccionar al menos un día.' });
				else
					this.setState({ isValidDays: true });
				if (!this.state.finalDate)
					this.setState({ errorFinalDate: 'Necesitas fijar una fecha final para la notificación.' });
				else
					this.setState({ isValidFinalDate: true });
				if (this.state.isValidDays && this.state.isValidFinalDate) {
					this.props.handleUpdate(tempId, title, description, image, days, hour, 'R', startDate, finalDate);
					this.clearForm();
				}
			} else {
				this.props.handleUpdate(tempId, title, description, image, [], hour, 'U', startDate, startDate);
				this.clearForm();
			}
		} else {
			this.props.handleUpdate(tempId, title, description, image, days, hour, this.state.isRecurrent ? "R" : "U", startDate, finalDate);
			this.clearForm();
		}

	}

	toggleCheckboxChange(e) {
		this.setState({
			isRecurrent: !this.state.isRecurrent
		})
	}

	async preparateSubmit() {
		await this.clearErrors();
		if (this.state.title === '' || isEmpty(this.state.title))
			this.setState({ errorTitle: 'El titulo de la notificación es requerida.' });
		else
			this.setState({ isValidTitle: true });

		if (this.state.description === '' || isEmpty(this.state.description))
			this.setState({ errorDescription: 'La descripción es requerida.' });
		else
			this.setState({ isValidDescription: true });

		if (this.state.hour === '' || isEmpty(this.state.hour))
			this.setState({ errorHour: 'El horario es requerido.' });
		else
			this.setState({ isValidHour: true });

		if (this.state.startDate === '' || isEmpty(this.state.startDate))
			this.setState({ errorStartDate: 'Necesitas fijar una fecha para la notificación.' });
		else
			this.setState({ isValidStartDate: true });

		if (this.state.isRecurrent) {
			if (this.state.days.length === 0)
				this.setState({ errorDays: 'Necesitas seleccionar al menos un día.' });
			if (!this.state.finalDate === '' || isEmpty(this.state.finalDate))
				this.setState({ errorFinalDate: 'Necesitas fijar una fecha final para la notificación.', isValidFinalDate: false });
			else
				this.setState({ isValidFinalDate: true });

		} else {
			this.setState({
				finalDate:        this.state.startDate,
				isValidFinalDate: true
			});
		}
		if (
			this.state.isValidTitle       &&
			this.state.isValidDescription &&
			this.state.isValidHour        &&
			this.state.isValidStartDate   &&
			this.state.isValidFinalDate
		) {
			this.props.handleSubmit(
				this.state.title,
				this.state.description,
				this.state.newImage ? this.state.newImage : "",
				this.state.days,
				this.state.hour,
				this.state.isRecurrent ? "R" : "U",
				this.state.startDate,
				this.state.finalDate
			)
			this.clearForm();
		}
	}

	onPressCancel() {
		this.farmazonFormRef.reset();
		this.titleForm.value       = null;
		this.descriptionForm.value = null;
		this.hourForm.value        = null;
		this.newImage              = null;
		this.startDateForm         = null;
		this.finalDateForm         = null;
		this.setState({
				errorTitle:       '',
				errorDescription: '',
				errorHour:        '',
				errorDays:        '',
				errorStartDate:   '',
				errorFinalDate:   '',
				title:            '',
				description:      '',
				hour:             '',
				image:            '',
				days:             [],
				MONDAY:           false,
				TUESDAY:          false,
				WEDNESDAY:        false,
				THURSDAY:         false,
				FRIDAY:           false,
				SATURDAY:         false,
				SUNDAY:           false,
				progress:         100,
				isRecurrent:      false,
				startDate:        '',
				finalDate:        '',
				newImage:         null
		}, () => {
			this.props.handleCancel();
		});
	}

	///---------------------------------------VIEW-------------------------------------
	render() {
		let title = 'CAPTURA LOS SIGUIENTES DATOS';
		if (this.props.type === 'UPDATE') {
			title = 'ACTUALIZA LOS DATOS';
		}
		let labelImage = null, finalDate  = null, startDate = null;
		if (this.props.notificationData) {
			labelImage = this.state.newImage  ? this.state.newImage  : this.props.notificationData.image     === '' ? '' : this.props.notificationData.image;
			startDate  = this.state.startDate ? this.state.startDate : this.props.notificationData.startDate === '' ? '' : this.props.notificationData.startDate;
			finalDate  = this.state.finalDate ? this.state.finalDate : this.props.notificationData.finalDate === '' ? '' : this.props.notificationData.finalDate;
		}
		if (startDate !== null) {
			startDate = startDate.substr(0, 10);
		}
		if (finalDate !== null) {
			finalDate = finalDate.substr(0, 10);
		}
		return (
			<div className= { this.props.isVisible ? "modal display-block" : "modal display-none"}>
				<div className="modal-notification-main">
					<Scrollbar style={{ width: "80%", height: "100%" }}>
						<div className="auth-group">
							{title}
							<div className="auth-label"></div>
							<div className="auth-label"></div>
							<form ref={(el) => { this.farmazonFormRef = el; }}>
								{
									this.props.notificationData && this.props.notificationData._id !== null &&
									<h2 className="bold2">ACTUALIZACIÓN DE LA IMAGEN.</h2>
								}
								{
									this.props.notificationData && this.props.notificationData._id === null &&
									<h2 className="bold2">SUBIR IMAGEN.</h2>
								}
								{
									(this.props.notificationData || this.state) &&
									<img
										src   = {this.state.newImage ? this.state.newImage : this.props.notificationData ? this.props.notificationData.image : ''}
										width = "40%"
										alt   = {labelImage}
									/>
								}
								<br/><br/>
								<center>
									<input
										type     = "file"
										id       = "theFile"
										accept   = ".jpg, .jpeg, .png"
										style    = {{ fontSize: "20px" }}
										onChange = { this.previewFile.bind(this) }
									/>
									<LinearProgress
										style   = {{ width: "90%" }}
										id      = "linearProgress"
										variant = "determinate"
										value   = { this.state.progress }
									/>
								</center>
								<br/>
								<Card>
									<h6 style = {{ fontSize: "14px" }}><b>Consideraciones:</b></h6>
									<p style = {{ fontSize: "10px" }}>
										<b>° Tamaño máximo permitido: </b> 500 KB (kilobytes) <br/>
										<b>° Formato de imagen: </b> .png <br/>
										<b>° Tamaño de imagen: </b> 1200x600 px
									</p>
								</Card>
								<br/>
								<table align="center" width="100%" cellPadding="0" cellSpacing="0" border="0">
									<tbody>
										<tr>
											<td><div className="auth-label">Titulo de la notificacion<span className="required">*</span></div></td>
											<td><div className="auth-label">Descripcion<span className="required">*</span></div></td>
											<td><div className="auth-label">Horario<span className="required">*</span></div></td>
										</tr>
										<tr>
											<td>
												<input
													id          = "titleForm"
													ref         = {(el) => {
														this.titleForm = el;
													}}
													onChange    = { this.onChangeTitle.bind(this) }
													value       = {
														this.state.title === '' ? (this.props.notificationData ? this.props.notificationData.title : "") : this.state.title
													}
													error       = {this.state.errorTitle}
													type        = "title"
													placeholder = { this.props.notificationData ? this.props.notificationData.title :
														"Ej.: Notificacion oferta"
													}
													className   = "local-store-input"
												/>
												<div className="auth-error">
													{this.state.errorTitle}
												</div>
											</td>
											<td>
												<input
													id="descriptionForm"
													ref={(el) => {
														this.descriptionForm = el;
													}}
													onChange={this.onChangeDescription.bind(this)}
													value={
														this.state.description === '' ? (this.props.notificationData ? this.props.notificationData.description : '') : this.state.description
													}
													error={this.state.errorDescription}
													type="title"
													placeholder={this.props.notificationData ? this.props.notificationData.description : 'Ej.: Aprovecha el paracetamol al 2x1' }
													className="local-store-input"
												/>
												<div className="auth-error">
													{this.state.errorDescription}
												</div>
											</td>
											<td>
												<input
													id       = "hourForm"
													ref      = {(el) => {
														this.hourForm = el;
													}}
													onChange  = { this.onChangeHour.bind(this) }
													value     = {
														this.state.hour === '' ? (this.props.notificationData ? this.props.notificationData.hour : '') : this.state.hour
													}
													error     = { this.state.errorHour }
													type      = "time"
													className = "local-store-input"
												/>
												<div className="auth-error">
													{this.state.errorHour}
												</div>
											</td>
										</tr>
										<tr>
											<td>
												<div className="auth-label">
													{
														this.state.isRecurrent ? "Fecha Inicio" : "Fecha notificación"
													}
													<span className="required">*</span></div></td>
											{
												this.state.isRecurrent &&
												<td><div className="auth-label">Fecha fin<span className="required">*</span></div></td>
											}
										</tr>
										<tr>
											<td>
												<input
													id        = "startDateForm"
													ref       = {(el) => {
														this.startDateForm = el;
													}}
													onChange  = { this.onChangeStartDate.bind(this) }						
													value     = {
														startDate
													}
													error     = {this.state.errorStartDate}
													type      = "date"
													className = "local-store-input"
												/>
												<div className="auth-error">
													{this.state.errorStartDate}
												</div>
											</td>
											{
												this.state.isRecurrent &&
												<td>
													<input
														id       = "finalDateForm"
														ref      = {(el) => {
															this.finalDateForm = el;
														}}
														onChange = {this.onChangeFinalDate.bind(this)}
														value    = {
															finalDate
														}
														error     = { this.state.errorFinalDate }
														type      = "date"
														className = "local-store-input"
													/>
													<div className="auth-error">
														{this.state.errorFinalDate}
													</div>
												</td>
											}
										</tr>
									</tbody>
								</table>
								<div className="auth-label">
									Notificacion recurrente
									<input
										type="checkbox"
										value="Notificacion recurrente"
										checked={this.state.isRecurrent}
										onChange={this.toggleCheckboxChange.bind(this)}
									/>
								</div>
								{this.state.isRecurrent &&
									<div>
										<label>{this.props.notificationData ? "Si deseas cambiar los días de notificacion seleccionalos, si no, no marques ningun día." : ""}</label>
										<br></br>
										<label>
											Lunes:
											<input
												name     = "MONDAY"
												type     = "checkbox"
												checked  = { this.state.MONDAY }
												onChange = { this.handleInputChange } />
										</label>
										<label>
											Martes:
											<input
												name    = "TUESDAY"
												type    = "checkbox"
												checked = { this.state.TUESDAY }
												onChange= { this.handleInputChange } />
										</label>
										<label>
											Miercoles:
											<input
												name     = "WEDNESDAY"
												type     = "checkbox"
												checked  = { this.state.WEDNESDAY }
												onChange = { this.handleInputChange } />
										</label>
										<br></br>
										<label>
											Jueves:
											<input
												name     = "THURSDAY"
												type     = "checkbox"
												checked  = { this.state.THURSDAY }
												onChange = { this.handleInputChange } />
										</label>
										<label>
											Viernes:
											<input
												name     = "FRIDAY"
												type     = "checkbox"
												checked  = { this.state.FRIDAY }
												onChange = { this.handleInputChange } />
										</label>
										<label>
											Sabado:
											<input
												name     = "SATURDAY"
												type     = "checkbox"
												checked  = { this.state.SATURDAY }
												onChange = { this.handleInputChange } />
										</label>
										<br></br>
										<center>
											<label>
												Domingo:
												<input
													name     = "SUNDAY"
													type     = "checkbox"
													checked  = {this.state.SUNDAY}
													onChange = {this.handleInputChange} />
											</label>
										</center>
									</div>
								}
								<div className="auth-error">{this.state.errorDays}</div>
							</form>
							<div className="modal-activity-section">
								{this.props.type === "UPDATE" && (
									<button className="modal-buttonOK" onClick={this.preparateUpdate.bind(this)}>
										ACTUALIZAR
									</button>
								)}
								{this.props.type !== "UPDATE" && (
									<button className="modal-buttonOK" onClick={this.preparateSubmit.bind(this)}>
										GUARDAR
									</button>
								)}
								{
									<button className="modal-buttonNo" onClick={this.onPressCancel.bind(this)}>
										CERRAR
									</button>
								}
							</div>
						</div>
					</Scrollbar>
					{
						<Snackbar open={this.state.showSnackBar} autoHideDuration={6000} onClose={this.handleClose}>
							<Alert onClose={this.handleClose} severity={this.state.severitySnackBar}>
								{this.state.textSnackBar}
							</Alert>
						</Snackbar>
					}
				</div>
			</div>
		);
	}
}

export default AddNotificationModal;
